import gql from 'graphql-tag'

export const DELETE_CUSTOM_LINK = gql`
  mutation DeleteShopGridCustomLink($input: DeleteShopGridCustomLinkInput!) {
    deleteShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          url
        }
      }
    }
  }
`

export const ADD_NEW_CUSTOM_LINK = gql`
  mutation AddNewShopGridCustomLink($input: AddShopGridCustomLinkInput!) {
    addShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          text
          url
        }
      }
    }
  }
`

export const UPDATE_CUSTOM_LINK_COLORS = gql`
  mutation UpdateShopGridCustomLinkColors(
    $input: UpdateCustomLinksColorsInput!
  ) {
    updateCustomLinksColors(input: $input) {
      ... on EmptySuccess {
        _empty
      }
    }
  }
`

export const UPDATE_CUSTOM_LINK = gql`
  mutation UpdateShopGridCustomLink($input: UpdateShopGridCustomLinkInput!) {
    updateShopGridCustomLink(input: $input) {
      ... on ShopGridCustomLinksPayload {
        color
        contrastColor
        links {
          id
          text
          url
        }
      }
    }
  }
`

export const SWAP_CUSTOM_LINKS = gql`
  mutation SwapShopGridCustomLinks($input: SwapShopGridCustomLinksInput!) {
    swapShopGridCustomLinks(input: $input) {
      ... on ShopGridCustomLinksPayload {
        links {
          id
          text
          url
        }
      }
    }
  }
`

export const UPDATE_POST_LINK = gql`
  mutation UpdateShopGridPostLink($input: UpdateShopGridPostLinkInput!) {
    updateShopGridPostLink(input: $input) {
      ... on EmptySuccess {
        _empty
      }
    }
  }
`
